import React from 'react';
import '../../App.css';

const LandingPageName = () => {
  return (
    <svg
      className='Name'
      version='1.1'
      id='Layer_1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      x='0px'
      y='0px'
      width='80%'
      viewBox='0 0 1263 787'
      enable-background='new 0 0 1263 787'
      xmlSpace='preserve'
    >
      <path
        fill='#FC9F45'
        opacity='1.000000'
        stroke='none'
        d='
M615.004150,400.969788 
	C624.808472,400.969757 634.113403,400.969757 644.119385,400.969757 
	C644.298645,404.589569 644.596436,407.839386 644.599548,411.089508 
	C644.633301,446.248413 644.547791,481.407562 644.651550,516.566223 
	C644.704407,534.461975 658.661438,547.436096 675.875488,545.922791 
	C691.491333,544.549927 703.859802,531.144592 703.874573,515.433167 
	C703.908447,479.274475 703.974121,443.115204 703.778687,406.957550 
	C703.752686,402.144989 705.085327,400.732391 709.895813,400.859253 
	C722.367249,401.188171 734.853088,400.969666 748.187744,400.969666 
	C748.187744,403.165222 748.187744,405.073914 748.187744,406.982605 
	C748.187866,442.641449 748.109558,478.300507 748.216248,513.959045 
	C748.284485,536.776245 768.522644,551.225830 790.169128,544.115723 
	C801.850098,540.278992 809.903076,528.598633 809.920044,515.160095 
	C809.965027,479.501312 809.934448,443.842438 809.934875,408.183624 
	C809.934937,400.970154 809.936707,400.970001 817.220642,400.969788 
	C827.551697,400.969513 837.884338,401.069733 848.213013,400.912109 
	C851.583862,400.860687 852.945862,401.829590 852.935059,405.417633 
	C852.833618,439.076599 852.998840,472.736603 852.828247,506.395020 
	C852.715393,528.657471 846.379883,548.650818 830.404724,564.960022 
	C813.058044,582.669434 791.797546,587.984619 767.812622,585.488525 
	C751.738037,583.815613 737.538086,578.057434 726.097778,567.418396 
	C718.340942,571.969543 711.492493,577.304382 703.741821,580.321167 
	C654.320435,599.557739 608.540283,569.145874 600.979431,523.644714 
	C600.489990,520.699585 600.072327,517.699036 600.067261,514.723511 
	C600.004761,477.898376 600.024353,441.073120 600.030090,404.247894 
	C600.030212,403.426788 600.117004,402.605682 600.209473,400.969788 
	C604.997070,400.969788 609.750916,400.969788 615.004150,400.969788 
z'
      />
      <path
        fill='#FC9F45'
        opacity='1.000000'
        stroke='none'
        d='
M98.587585,54.230003 
	C116.956993,55.673347 134.311020,59.316532 150.217178,67.987991 
	C179.110107,83.739357 200.471695,106.104561 210.108932,138.243530 
	C215.194901,155.204666 215.949570,172.478394 213.324463,190.063690 
	C208.042206,225.448929 189.828079,252.552124 160.822495,272.602783 
	C143.673416,284.457397 124.204735,289.779663 103.389297,289.942108 
	C87.063957,290.069519 70.736832,289.967438 54.410500,289.967316 
	C52.787045,289.967316 51.163589,289.967316 49.246616,289.967316 
	C49.246616,211.288696 49.246616,133.073120 49.246616,54.182835 
	C65.609215,54.182835 81.867249,54.182835 98.587585,54.230003 
M114.669296,100.744537 
	C108.461624,99.729454 102.229347,98.841599 96.056206,97.647934 
	C92.754601,97.009521 92.005844,98.286362 92.009369,101.296097 
	C92.064400,148.238831 92.069992,195.181686 92.000252,242.124374 
	C91.995789,245.128830 93.009277,246.642456 95.995148,246.208893 
	C102.866814,245.211105 109.953537,244.837921 116.535156,242.836945 
	C161.581085,229.141769 177.893661,189.899841 167.912552,151.204849 
	C160.952560,124.222237 140.340637,109.991013 114.669296,100.744537 
z'
      />
      <path
        fill='#FC9F45'
        opacity='1.000000'
        stroke='none'
        d='
M444.640076,524.278870 
	C469.490356,560.836975 518.122314,550.519348 533.454956,522.090210 
	C536.710693,516.053589 538.642822,508.531403 538.708130,501.670105 
	C539.155273,454.680115 538.942444,407.683838 538.942200,360.689606 
	C538.942200,358.704498 538.942200,356.719391 538.942200,354.319519 
	C551.599121,354.319519 563.981079,354.319519 577.087585,354.319519 
	C577.087585,356.215210 577.087585,358.143219 577.087585,360.071228 
	C577.087585,405.898956 576.807007,451.729034 577.192566,497.553528 
	C577.425110,525.197327 566.547058,547.208435 545.742981,564.720886 
	C515.561829,590.126831 471.928955,593.114441 438.626740,572.190979 
	C408.545044,553.290955 393.104919,516.813110 398.420624,481.694763 
	C403.923248,445.341400 433.526459,414.701538 474.290863,409.028290 
	C491.461639,406.638641 507.800079,408.474121 523.468323,415.765747 
	C525.065674,416.509094 527.049133,418.654510 527.079163,420.184113 
	C527.340759,433.508911 527.202026,446.841705 527.154480,460.171997 
	C527.152893,460.623077 526.858704,461.073120 526.690552,461.553253 
	C499.584381,442.053925 472.385162,437.628723 447.166504,463.599365 
	C433.132507,478.051758 432.980286,505.857666 444.640076,524.278870 
z'
      />
      <path
        fill='#FC9F45'
        opacity='1.000000'
        stroke='none'
        d='
M284.168030,227.717407 
	C299.306549,255.213165 342.973755,267.763977 374.305237,238.889755 
	C374.448883,240.935654 374.651550,242.508255 374.655029,244.081284 
	C374.680420,255.578308 374.357971,267.087372 374.803528,278.567108 
	C375.003998,283.731781 372.921844,285.930511 368.484009,287.644348 
	C328.974152,302.902496 295.136414,293.948669 264.096405,265.966064 
	C230.405258,235.593445 229.117508,176.933701 254.358856,143.556931 
	C278.665802,111.415703 322.236877,96.370743 360.854248,109.207672 
	C394.646667,120.440704 417.339172,142.830322 426.035675,178.003738 
	C427.497650,183.916687 428.081146,190.179794 428.124847,196.287888 
	C428.334534,225.612289 428.119171,254.939728 428.322327,284.264221 
	C428.354706,288.937286 426.958435,290.198639 422.387726,290.074158 
	C410.775879,289.757904 399.149689,289.969025 386.942627,289.969025 
	C386.942627,287.726776 386.942688,285.947357 386.942688,284.167908 
	C386.942657,256.008392 386.505463,227.840118 387.068665,199.691849 
	C387.603760,172.949356 369.607666,154.133118 348.394501,147.552460 
	C321.170227,139.107071 292.708527,151.128159 281.393433,176.476562 
	C273.727997,193.648849 275.093323,210.831253 284.168030,227.717407 
z'
      />
      <path
        fill='#FC9F46'
        opacity='1.000000'
        stroke='none'
        d='
M289.281555,547.360229 
	C301.289185,546.232971 311.686462,542.371887 320.637390,534.759155 
	C321.660095,533.889282 324.383942,533.350586 325.053009,533.987671 
	C333.350311,541.889526 341.412781,550.037964 349.828217,558.414124 
	C342.867615,566.386047 335.055359,572.376404 326.213959,576.567627 
	C280.483887,598.246216 222.826004,582.996216 198.011246,533.802856 
	C170.631409,479.524445 206.054062,412.040009 265.996918,402.061951 
	C323.377411,392.510376 371.120544,438.136322 377.333221,482.027496 
	C378.488739,490.190979 378.199463,498.567963 378.416107,506.850616 
	C378.493683,509.816620 377.039978,511.020782 373.735199,511.011017 
	C331.247742,510.885315 288.759705,510.900757 246.272003,510.974304 
	C242.320312,510.981140 239.461105,509.530792 239.150925,505.637848 
	C238.585861,498.545807 238.450089,491.402649 238.521759,484.284698 
	C238.552277,481.254456 240.747421,479.576782 243.882828,479.494537 
	C246.046829,479.437744 248.211914,479.389740 250.376465,479.391724 
	C278.034058,479.416992 305.691681,479.456207 333.349274,479.466736 
	C334.312958,479.467102 335.276764,479.206024 336.246704,479.065918 
	C331.819489,454.248840 306.607452,436.981384 278.495453,439.303345 
	C247.884125,441.831726 224.805832,469.218689 227.902618,498.320129 
	C231.210648,529.406616 258.153961,551.117554 289.281555,547.360229 
z'
      />
      <path
        fill='#FC9F46'
        opacity='1.000000'
        stroke='none'
        d='
M937.764648,583.244446 
	C906.855896,575.733215 886.069702,556.702515 876.383545,527.484192 
	C865.191040,493.721710 869.440125,461.299805 892.248657,432.788055 
	C905.926514,415.690033 924.088135,405.843994 945.675293,402.509644 
	C970.574219,398.663757 994.606873,400.881805 1016.324219,414.813446 
	C1036.977173,428.062286 1049.552490,447.110199 1054.184814,471.198578 
	C1058.476685,493.515289 1057.131226,515.443054 1046.813110,535.984253 
	C1032.566162,564.347168 1009.451538,580.765198 977.851135,585.030212 
	C964.511292,586.830688 951.298767,586.204651 937.764648,583.244446 
M914.756104,511.577179 
	C916.966248,516.025513 918.647156,520.847107 921.476746,524.858521 
	C934.772949,543.707825 959.503723,550.797485 983.536438,543.220398 
	C1003.555298,536.908936 1021.483337,516.438538 1019.177307,485.604279 
	C1017.469299,462.765930 1001.085938,444.168365 977.324341,440.136139 
	C958.457886,436.934570 941.007935,440.499664 927.248535,454.685883 
	C911.771729,470.642822 909.506897,490.006531 914.756104,511.577179 
z'
      />
      <path
        fill='#FC9F45'
        opacity='1.000000'
        stroke='none'
        d='
M457.015930,199.000046 
	C457.433105,189.702240 456.838409,180.714844 458.445068,172.139893 
	C464.902863,137.674179 491.582214,112.041603 526.142700,106.152008 
	C569.121948,98.827736 608.661011,123.885551 620.377136,166.083527 
	C621.788452,171.166809 622.750244,176.556915 622.782104,181.811722 
	C622.993286,216.634766 622.895386,251.459686 622.886841,286.283997 
	C622.886597,287.260529 622.760681,288.237030 622.641296,289.968597 
	C618.767334,289.968597 615.011719,289.968658 611.256104,289.968567 
	C602.591675,289.968445 593.919006,289.743896 585.266418,290.063232 
	C580.974976,290.221619 579.915405,288.678986 579.931946,284.635193 
	C580.061646,252.977280 580.003052,221.318558 580.003052,189.660095 
	C580.002991,168.361115 568.859680,154.305344 548.062073,149.372269 
	C529.570740,144.986237 509.750732,154.271179 502.403015,171.480179 
	C500.246948,176.529816 499.231842,182.430634 499.180969,187.955017 
	C498.886322,219.944016 499.036377,251.937119 499.035980,283.928833 
	C499.035950,285.723358 499.035980,287.517883 499.035980,289.638947 
	C485.006378,289.638947 471.421051,289.638947 457.015930,289.638947 
	C457.015930,259.644196 457.015930,229.572113 457.015930,199.000046 
z'
      />
      <path
        fill='#FC9F46'
        opacity='1.000000'
        stroke='none'
        d='
M50.789833,422.000000 
	C50.789700,397.893707 50.789700,374.287384 50.789700,350.162903 
	C64.356377,350.162903 77.305634,350.107819 90.251656,350.286804 
	C91.115150,350.298737 92.245544,351.963501 92.717117,353.084412 
	C93.133972,354.075317 92.803909,355.380402 92.803902,356.546753 
	C92.803802,416.364960 92.871048,476.183411 92.683441,536.001038 
	C92.667412,541.114685 94.051773,542.426392 99.079323,542.363953 
	C121.070381,542.090942 143.066742,542.245300 165.061172,542.244507 
	C166.846649,542.244446 168.632126,542.244507 170.708771,542.244507 
	C170.708771,556.918396 170.708771,571.015442 170.708771,585.542236 
	C131.060059,585.542236 91.350624,585.542236 50.789963,585.542236 
	C50.789963,531.291016 50.789963,476.895508 50.789833,422.000000 
z'
      />
      <path
        fill='#FC9F46'
        opacity='1.000000'
        stroke='none'
        d='
M1186.610474,427.987732 
	C1188.005127,437.527191 1185.793945,442.836090 1175.900757,446.925018 
	C1161.483398,452.883759 1153.946167,465.248413 1153.720459,481.786987 
	C1153.516968,496.704163 1153.282715,511.814880 1150.828003,526.465942 
	C1146.127563,554.520142 1118.719971,580.258301 1090.670654,584.760803 
	C1085.984741,585.513062 1081.220093,585.775330 1076.101685,586.304321 
	C1075.978271,583.889404 1075.828003,582.273621 1075.824097,580.657471 
	C1075.801636,571.166565 1076.068970,561.665894 1075.709595,552.188660 
	C1075.519043,547.163330 1076.618652,544.816528 1082.098633,543.322327 
	C1100.436035,538.322754 1113.659424,520.321106 1113.853149,501.323273 
	C1114.017944,485.169495 1114.189087,468.922516 1119.061279,453.403259 
	C1126.674927,429.151398 1148.380493,403.061737 1180.090820,401.087585 
	C1186.553589,400.685211 1186.595215,400.713654 1186.607788,407.010040 
	C1186.621338,413.836884 1186.610840,420.663818 1186.610474,427.987732 
z'
      />
    </svg>
  );
};

export default LandingPageName;
